'use client';

import { ComponentProps } from 'react';
import Image, { StaticImageData } from 'next/image';
import { Img } from '@/shared/components/image';
import { cn } from '@/shared/utils/style/cn';

const DEFAULT_PROFILE = '/images/default-profile.png';

/**
 * src 값이 없으면 기본 프로필 이미지 반환
 * 기본 스타일 'border-gray20 rounded-full border' 적용
 * 기본적으로 responsive=true로 설정
 * */
export function ProfileImage({
  imagePath = DEFAULT_PROFILE,
  className,
  responsive = true,
  ...props
}: Omit<ComponentProps<typeof Image>, 'objectFit' | 'style' | 'src' | 'alt'> & {
  responsive?: boolean;
  imagePath?: string | StaticImageData;
}) {
  return (
    <Img
      {...props}
      responsive={responsive}
      className={cn('border-gray20 rounded-full border', className)}
      src={imagePath}
      alt="profile-image"
    />
  );
}
